import './support.scss';

import React, { useEffect } from 'react';
import { Container, Typography, Box, Link, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Translate, translate } from 'react-jhipster';
import { useHistory } from 'react-router-dom';

const Support = () => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  return (
    <Container maxWidth="md" className="support-page" sx={{ py: 5 }}>
      <Button
        onClick={handleBack}
        startIcon={<ArrowBackIcon />}
        className="support-back-btn"
        aria-label={translate('entity.action.back')}
        sx={{ mb: 4 }}
      >
        <Translate contentKey="entity.action.back">Back</Translate>
      </Button>

      <Typography variant="h4" component="h1" gutterBottom>
        <Translate contentKey="comexApp.support.title">Support</Translate>
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        <Translate contentKey="comexApp.support.subtitle">Comex Platform Web &amp; Mobile Application</Translate>
      </Typography>

      <Typography paragraph sx={{ mt: 3 }}>
        <Translate contentKey="comexApp.support.intro">
          For help with your account, transactions, or the Al Shmokh mobile app, contact our support team using the details below.
        </Translate>
      </Typography>

      <Box className="support-contact-box">
        <Typography component="p">
          <Translate contentKey="comexApp.support.hotlineLabel">Hotline</Translate>:{' '}
          <Link href="tel:+96522009900" style={{ unicodeBidi: 'bidi-override', direction: 'ltr', display: 'inline-block' }}>
            +965 2200 9900
          </Link>
        </Typography>
        <Typography component="p">
          <Translate contentKey="comexApp.support.emailLabel">Email</Translate>:{' '}
          <Link href="mailto:acc@sh-global.com">acc@sh-global.com</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Support;
